import BaseCurdInfo from './BaseCurdInfo'

const PAGE = 1
const SIZE = 50

export default {
  name: 'BaseList',
  extends: BaseCurdInfo,
  data () {
    return {
      query: {},
      pagination: {
        pageNum: PAGE,
        pageSize: SIZE
      },
      list: [],
      total: 0,
      selectedList: []
    }
  },
  computed: {
    listPage: () => false
  },
  methods: {
    afterQuery () {},
    getTable () {
      return this.$refs.table
    },
    getList () {
      this.changeLoadStatus(true)

      let promise = (this.listPage ? this.$api[this.apiKey].getPageList({
        ...this.query,
        ...this.pagination
      }) : this.$api[this.apiKey].getList(this.query))

      return promise.then(data => {
        this.setList(data)
        this.afterQuery()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onDelete (data) {
      this.changeLoadStatus(true)
      this.$api[this.apiKey].delete(data[this.idKey]).then(this.deleteSuccess).catch(this.deleteFailed).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onBatchDelete () {
      return this.$api[this.apiKey].delete(this.selectedList.toString()).then(this.deleteSuccess).catch(this.deleteFailed)
    },
    setList (data) {
      if (this.listPage) {
        this.list = Object.freeze(data.records || [])
        this.total = data.total | 0
      } else if (data) {
        this.list = Object.freeze(data || [])
      }
    },
    search () {
      this.clearSelectedList()
      this.getList()
    },
    onSearch () {
      let pagination = this.pagination
      pagination.pageNum = 1
      this.search()
    },
    onPageNumChange () {
      this.search()
    },
    onPageSizeChange () {
      this.search()
    },
    onSelectionChange (selectedList) {
      let idKey = this.idKey
      this.selectedList = selectedList.map(item => item[idKey])
    },
    clearSelectedList () {
      this.selectedList = []
    },
    deleteSuccess () {
      this.search()
      this.$notify({
        title: '成功',
        message: '删除成功',
        type: 'success',
        position: 'bottom-right'
      })
    },
    deleteFailed () {
      this.$notify.error({
        title: '失败',
        message: '删除失败',
        position: 'bottom-right'
      })
    },
    onShowDeleteConfirmDialog (data) {
      let name = data[this.nameKey]

      this.$confirm(`此操作将永久删除${name ? `'${name}'` : '该记录'}, 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.onDelete(data)
      }).catch(() => {})
    },
    onShowDeleteAllConfirmDialog (name) {
      this.$confirm(`此操作将永久删除所有选中的${name}, 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.onBatchDelete()
      }).catch(() => {})
    },
    onChangeStatus (data, flag) {
      this.changeLoadStatus(true)

      this.$api[this.apiKey].changeStatus(data[this.idKey], flag).then(data => {}).catch(err => {
        console.error(err)
        data.status = !flag
      }).finally(() => {
        data = null
        this.changeLoadStatus(false)
      })
    },
    onInputEnter () {
      this.onSearch()
      this.$refs.kwInput.blur()
    },
    onCancelHighlightTableRow () {
      let refTable = this.getTable()
      refTable && refTable.setCurrentRow()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseList.js